var _style, _ellipse, _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.1;enable-background:new    ;}\n\t.st1{fill:#E94364;stroke:#5F5C74;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 125,
    cy: 227.8,
    rx: 112.5,
    ry: 19.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206,148.9c0,45.9-37.2,78.9-83,78.9s-83-33-83-78.9C40,72.1,123,7.8,123,7.8S206,72.1,206,148.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st1",
    d: "M234.2,77c0,20.5-16.6,35.3-37.2,35.3c-20.5,0-37.2-14.8-37.2-35.3c0-34.4,37.2-63.2,37.2-63.2 S234.2,42.6,234.2,77z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_2_",
    className: "st2",
    x1: 185.4,
    y1: 73.2,
    x2: 208.7,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st2",
    d: "M197,84.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st2",
    d: "M197,61.6"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st3",
    d: "M126.5,151.8h-13.1c-1.9,0-3.2-0.4-4.1-1.3c-0.8-0.8-1.2-2.2-1.2-4.1v-32.3 c0-1.9,0.4-3.3,1.2-4.1c0.8-0.8,2.2-1.2,4-1.2h13.9c2.1,0,3.8,0.1,5.3,0.4s2.9,0.7,4,1.5c1,0.6,1.9,1.4,2.7,2.3s1.4,2,1.8,3.1 c0.4,1.1,0.6,2.3,0.6,3.6c0,4.3-2.1,7.4-6.4,9.4c5.6,1.8,8.5,5.3,8.5,10.5c0,2.4-0.6,4.6-1.8,6.5s-2.9,3.3-5,4.3 c-1.3,0.5-2.8,0.9-4.5,1.2S128.7,151.8,126.5,151.8z M116.8,115.4v11.1h8c2.2,0,3.8-0.2,5-0.6s2.1-1.2,2.7-2.3 c0.5-0.8,0.7-1.7,0.7-2.8c0-2.2-0.8-3.6-2.3-4.3c-1.5-0.7-3.9-1.1-7.1-1.1C123.8,115.4,116.8,115.4,116.8,115.4z M125.8,132.8h-9.1 v12.5h9.3c5.9,0,8.8-2.1,8.8-6.4c0-2.2-0.8-3.7-2.3-4.7S128.8,132.8,125.8,132.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/b-.b6cd4366b568ad0ca8ae2546765fc9a3.svg";
export { ForwardRef as ReactComponent };